<!--
 * @Author: wufei
 * @Date: 2020-08-07 11:01:31
 * @LastEditTime: 2020-08-20 10:17:01
 * @Description:
 * @FilePath: \mobile-revive\src\components\Ell\index.vue
-->
<template>
  <div class="ell" style="line-height:normal;">
    <div v-if="state && params.renderState" class="ell-box">
      <!-- 占位使用 -->
      <p ref="JLineHeight">d</p>
      <p v-businessDescription="{express:businessDescriptionFilter,vnode:'JLineHeight'}" @click="state = false" v-html="text || '--'" />
      <icon
        v-if="state"
        ref="arrow"
        name="arrow-down"
        :style="{bottom:arrowBottom+'px'}"
      />
    </div>
    <p v-else @click="state = true">
      <span v-html="params.content || '--'" />
    </p>
  </div>
</template>

<script>
import { clamp } from '@/assets/js/clamp'
import { Icon } from 'vant'
export default {
    components: {
        Icon
    },
    directives: {
        businessDescription: {
            inserted: function(el, bindings, vnode) {
                bindings.value.express(el, bindings.value.vnode)
                const text = el.innerHTML
                if (text.endsWith('...')) {
                    el.nextElementSibling.style.display = 'line'
                } else {
                    el.nextElementSibling.style.display = 'none'
                }
                el.previousElementSibling.style.display = 'none'
            }
        }
    },
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            state: true,
            arrowBottom: 0,
            text: ''
        }
    },
    watch: {
        'params.content': function(n) {
            if (this.params.content) {
                this.text = this.params.content.replace(/<.*?>/g, '')
            }
        }
    },
    created() {
        if (this.params.content) {
            this.text = this.params.content.replace(/<.*?>/g, '')
        }
    },
    methods: {
        businessDescriptionFilter(ele, refName) {
            let line = this.params.line
            let H = this.$refs[refName].offsetHeight || ele.previousElementSibling.offsetHeight
            let arrowH = this.$refs.arrow.offsetHeight
            this.arrowBottom = H / line - (arrowH / line)
            if (!ele) return
            clamp(ele, { clamp: line, useNativeClamp: false, lineHeigth: H })
        }
    }
}
</script>

<style lang="scss" scoped>
  .ell {
    .ell-box {
      position:relative;
      text-align:left;
      i {
        position:absolute;
        bottom:0;
        right:0;
      }
    }
  }
</style>
